import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// The service worker serves only hashed assets and only for the app; the
// console needs no install. Registration failure changes nothing.
if ("serviceWorker" in navigator && window.location.pathname.startsWith("/app") && !import.meta.env.DEV) {
  navigator.serviceWorker.register("/sw.js").catch(() => undefined);
}
